import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Products.css'; // Your existing Products.css
import '../assets/css/general.css'; // Assuming this holds common styles like variables

// Import product images for the main categories
import bigbagsImage from '../assets/img/products/bigbag.jpg'; // For Big Bags (FIBC)
import bagsCombinedImage from '../assets/img/products/sack.jpg'; // For combined PP & Kraft Sacks
import specialProductsImage from '../assets/img/products/pefilm/pefilm3.jpg'; // For Special Products

const ProductsPage = () => {
  // Set initial active category to 'big-bags' or the first one if available
  const initialCategory = 'big-bags';
  const [activeCategory, setActiveCategory] = useState(initialCategory);

  const productCategories = [
    {
      id: 'big-bags',
      name: 'Big Bags (FIBC)',
      description: 'Explore our comprehensive range of Flexible Intermediate Bulk Containers (FIBCs), designed for transporting and storing a wide variety of dry flowable products. Click for more details on specific types like Standard, 1&2 Loop, 4 Loop, Ventilated, and Q-Bags.',
      image: bigbagsImage,
      features: ['Wide Range of Types', 'Customizable Solutions', 'High Strength and Durability', 'Cost-Effective Bulk Handling', 'Suitable for Various Industries']
    },
    {
      id: 'bags',
      name: 'PP & Kraft Bags',
      description: 'We offer a versatile range of Polypropylene (PP) and eco-friendly Kraft paper bags. Ideal for packaging agricultural products, food items, construction materials, and chemicals, with options like Laminated, BOPP, Block Bottom, and more.',
      image: bagsCombinedImage,
      features: ['Durable PP & Eco-Friendly Kraft', 'High Tear Strength', 'Moisture Resistant Options', 'Printable for Branding', 'Multiple Construction Types']
    },
    {
      id: 'special-products',
      name: 'Special Products',
      description: 'Discover our custom-engineered packaging solutions, including specialized PE films for barrier protection and high-strength twines for industrial use. We tailor products to meet your unique requirements.',
      image: specialProductsImage,
      features: ['Tailor-Made Designs', 'Specialized PE Films & Twines', 'Engineered for Specific Applications', 'Innovative Problem-Solving', 'Consultation & Prototyping']
    }
  ];

  // Ensure activeProduct is found, or default to the first category if the state is somehow invalid
  let activeProduct = productCategories.find(category => category.id === activeCategory);
  if (!activeProduct && productCategories.length > 0) {
    activeProduct = productCategories[0];
    // setActiveCategory(productCategories[0].id); // Avoid direct state update in render logic
  }


  if (!activeProduct) {
    return (
        <main id="main" className="products-page">
            <section id="breadcrumbs" className="breadcrumbs">
                <div className="container">
                    <ol>
                        <li><Link to="/"><i className="fas fa-home"></i></Link></li>
                        <li>Products</li>
                    </ol>
                </div>
            </section>
            <div className="container" style={{textAlign: 'center', padding: '40px 0'}}>
                <p>No products available at the moment. Please check back later.</p>
            </div>
        </main>
    );
  }

  return (
    <main id="main" className="products-page">
      <section id="breadcrumbs" className="breadcrumbs">
        <div className="container">
          <ol>
            <li><Link to="/"><i className="fas fa-home"></i></Link></li>
            <li>Products</li>
          </ol>
        </div>
      </section>

      <div className="container">
        <div className="section-title">
          <h2>Our Products</h2>
          <div className="title-bar"></div>
          <p style={{ marginTop: '20px', fontSize: '18px', color: 'var(--gray-color)' }}>Discover our wide range of high-quality packaging solutions</p>
        </div>

        <div className="product-navigation">
          {productCategories.map(category => (
            <button
              key={category.id}
              className={`product-nav-button ${activeProduct && activeProduct.id === category.id ? 'active' : ''}`}
              onClick={() => setActiveCategory(category.id)}
            >
              {category.name}
            </button>
          ))}
        </div>

        {activeProduct && (
          <div className="product-content-card">
            <div className="product-image-container">
              <img
                src={activeProduct.image}
                alt={activeProduct.name}
                className="product-image"
              />
            </div>

            <div className="product-details">
              <h3 className="product-name">{activeProduct.name}</h3>
              <p className="product-description">{activeProduct.description}</p>

              <div className="product-features">
                <h4>Key Features</h4>
                <ul>
                  {activeProduct.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>
              
              <Link to={`/products/${activeProduct.id}`} className="inquiry-button" style={{ textDecoration: 'none' }}>
                More Information
              </Link>
            </div>
          </div>
        )}

        <div className="product-gallery-section">
          <div className="section-title">
            <h2>All Product Categories</h2>
            <div className="title-bar"></div>
          </div>
          <div className="gallery-grid">
            {productCategories.map(category => (
              <Link key={category.id} to={`/products/${category.id}`} className="gallery-item-link" style={{ textDecoration: 'none' }}>
                <div className="gallery-item">
                  <div className="gallery-image-wrapper">
                    <img src={category.image} alt={category.name} className="gallery-image" />
                  </div>
                  <h4 className="gallery-item-name">{category.name}</h4>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};

export default ProductsPage;